module.exports = __webpack_public_path__ + "img/image-disclaimer_device.02695cbe.png";